import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const values = [
  { icon: "ri-group-2-line", title: "同好至上", desc: "我们相信热爱能连接彼此，让每一个追漫的人都找到归属。" },
  { icon: "ri-discuss-line", title: "真诚交流", desc: "欢迎不同观点，鼓励友善讨论，拒绝无意义的争吵与拉踩。" },
  { icon: "ri-lightbulb-flash-line", title: "尊重创作", desc: "尊重每一位作者的辛勤付出，也尊重每一位读者的热爱。" },
  { icon: "ri-community-line", title: "开放包容", desc: "无论新粉老粉、冷门热坑，在这里都有你的一席之地。" },
];

const testimonials = [
  { name: "追漫十年的小K", role: "热血追番组 圈友", content: "以前追冷门番总是一个人，进了178漫圈之后发现原来有这么多同好，每天都能聊到停不下来。" },
  { name: "咸鱼漫友", role: "奇幻世界观 圈友", content: "设定考据楼太强了，大家把世界观扒得明明白白，看漫画的乐趣直接翻倍，这就是同好的力量。" },
  { name: "周末漫画家", role: "漫画绘技营 圈友", content: "在这里晒稿求点评，进步特别快。圈里的大佬都很热心，氛围超好，真的像一家人。" },
];

export default function About() {
  useSeo(
    "关于我们 - 178漫画网，漫友同好交流聚集地",
    "178漫画网是漫友同好交流聚集地，坚持同好至上、真诚交流、尊重创作、开放包容。了解我们的品牌介绍、网站定位、发展理念与内容原则。",
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="pt-16 md:pt-20">
        <section className="bg-background-100 border-b border-background-200">
          <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
            <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
              <Link to="/" className="hover:text-primary-600">首页</Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-foreground-700">关于我们</span>
            </nav>
            <h1 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">关于178漫画网</h1>
            <p className="mt-2 max-w-2xl text-sm md:text-base text-foreground-600">
              178漫画网是漫友同好交流聚集地，按作品和题材划分漫圈，让每一位追漫人都能找到聊得来的同好。
            </p>
          </div>
        </section>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <span className="text-xs font-medium tracking-widest text-accent-600">品牌介绍</span>
                <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">我们为什么做178漫画网</h2>
                <p className="mt-4 text-sm md:text-base leading-7 text-foreground-700">
                  很多追漫的人都有过这样的时刻——看到精彩情节却无人分享，追到冷门作品却找不到同好。
                  178漫画网就是为这样的漫友而生的。我们把漫画按作品和题材划分成一个个漫圈，让同好们在专属的讨论区里交流剧情、分享心得。
                </p>
                <p className="mt-3 text-sm md:text-base leading-7 text-foreground-700">
                  我们相信，好的作品值得被好好讨论，热爱它的人也值得被温柔以待。在这里混个脸熟，从此追漫有人陪聊。
                </p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {["同好至上", "真诚交流", "尊重创作", "开放包容"].map((v) => (
                    <span key={v} className="rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-700">{v}</span>
                  ))}
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20friends%20reading%20and%20discussing%20comics%20together%20around%20a%20table%20with%20warm%20drinks%2C%20coral%20orange%20and%20teal%20palette%2C%20cozy%20friendly%20community%20feeling%2C%20manga%20style%20illustration%2C%20high%20detail&width=1200&height=800&seq=about-brand&orientation=landscape"
                  alt="178漫画网漫友同好交流"
                  className="h-full w-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="text-center">
              <span className="text-xs font-medium tracking-widest text-accent-600">发展理念</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">我们坚持的社区理念</h2>
              <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-foreground-600">一个好的漫圈，靠的是每一个友善的同好共同维护。</p>
            </div>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl border border-background-200 bg-background-50 p-6 text-center">
                  <span className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-primary-500 text-background-50 text-xl">
                    <i className={v.icon} />
                  </span>
                  <h3 className="mt-4 font-heading text-lg text-foreground-950">{v.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="text-center">
              <span className="text-xs font-medium tracking-widest text-accent-600">用户口碑</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">漫友们怎么说</h2>
            </div>
            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-100 p-6">
                  <div className="flex gap-1 text-secondary-500">
                    {Array.from({ length: 5 }).map((_, i) => <i key={i} className="ri-star-fill text-sm" />)}
                  </div>
                  <blockquote className="mt-3 text-sm leading-7 text-foreground-700">"{t.content}"</blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="grid h-9 w-9 place-items-center rounded-full bg-accent-100 text-accent-700 font-bold text-sm">{t.name.slice(0, 1)}</span>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-12 md:py-16">
          <div className="mx-auto max-w-7xl px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <span className="text-xs font-medium tracking-widest text-accent-600">联系我们</span>
                <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">和我们保持联系</h2>
                <p className="mt-3 text-sm md:text-base text-foreground-600">
                  无论是建议、合作还是任何问题，都欢迎通过邮箱联系我们。你的每一条反馈，都能帮助我们把这个漫圈社区做得更好。
                </p>
                <div className="mt-6 flex flex-col gap-3 text-sm text-foreground-700">
                  <span className="inline-flex items-center gap-2"><i className="ri-mail-line text-primary-600" /> hello@178manhua.cn</span>
                  <span className="inline-flex items-center gap-2"><i className="ri-question-line text-primary-600" /> 常见问题见下方，或进入各漫圈提问</span>
                </div>
              </div>
              <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
                <h3 className="font-heading text-lg text-foreground-950">常见问题</h3>
                <div className="mt-4 flex flex-col gap-3">
                  {[
                    ["178漫画网需要付费吗？", "常规的漫圈交流、发帖回帖、浏览讨论区均免费。部分增值功能可能会单独说明。"],
                    ["如何找到同好一起讨论剧情？", "进入漫圈社区，找到对应作品或题材的圈子加入，即可发帖回帖，随时找到同好交流剧情、分享心得。"],
                    ["为什么按作品和题材划分漫圈？", "这样能让有共同兴趣的漫友更精准地聚集，讨论更聚焦、氛围也更友好，追漫有人陪聊。"],
                  ].map(([q, a]) => (
                    <details key={q} className="group rounded-xl border border-background-200 bg-background-100 px-4 py-3 open:border-primary-300">
                      <summary className="flex cursor-pointer list-none items-center justify-between gap-2 text-sm font-medium text-foreground-900">
                        {q}
                        <i className="ri-add-line text-primary-600 transition-transform group-open:rotate-45" />
                      </summary>
                      <p className="mt-2 text-sm leading-6 text-foreground-600">{a}</p>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}